var React = require('react');

function SocialWattpad (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Wattpad-2","data-name":"Wattpad","d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.9,10.9c-2.1,3.3-2.2,5.4-4.2,5.5-1,.1-2-.8-2.2-2.3V12.5c-1.6,2.7-2,5.8-4.7,5.3C4.3,17.1,4.1,12,4.6,9.4A4.29,4.29,0,0,1,5,8a1.78,1.78,0,0,1,2.9-.5c.7.8.5,2.4.4,3.5.9-1.6,2.9-4.6,4.6-4.4.2.1.5.1.7.2,1.1.6,1.1,2.3.9,3.5C15.4,9.1,17.6,6.5,19,7a1,1,0,0,1,.6.5C19.8,8.4,19.1,8.9,17.9,10.9Z","fill":"#FFF"}));
}

SocialWattpad.defaultProps = {"width":"24","height":"24","id":"wattpad","viewBox":"0 0 24 24"};

module.exports = SocialWattpad;

SocialWattpad.default = SocialWattpad;
